export default "__VITE_ASSET__Cy9iabgA__"